export class SalesOrderItemData {
  public constructor(
    public discount: number,
    public quantity: number,
    public sale_price: number,
    public meta_data: Record<string, any>,
  ) {
  }
}
